import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FaFastForward, FaFastBackward } from '../util/reactIcons';
import { useTranslation } from 'react-i18next';
import { PaginationArea, RowsDropdown, PaginationButtons } from './StyledPagination';
import allActions from '../actions';

export const TablePagination = ({ setPrevPage }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const manager = useSelector((state) => state.manager);
  const { currentPage, rowsPerPage, pageOptions, isNextPageAvailable } = manager;

  const nextPage = () => {
    isNextPageAvailable && dispatch(allActions.Manager.setCurrentPage(currentPage + 1));
    setPrevPage(currentPage);
  };

  const prevPage = () => {
    currentPage > 0 && dispatch(allActions.Manager.setCurrentPage(currentPage - 1));
    setPrevPage(currentPage);
  };

  const onRowsPerPageChange = (event) => {
    dispatch(allActions.Manager.setRowsPerPage(event.target.value));
  };

  const renderRowsPerPageDropdown = () => (
    <>
      <span>{t('tablePagination.show')}</span>
      <select onChange={onRowsPerPageChange} defaultValue={rowsPerPage}>
        {pageOptions.map((pageNumber) => (
          <option key={pageNumber} value={pageNumber}>
            {pageNumber}
          </option>
        ))}
      </select>
      <span>{t('tablePagination.rowsperpage')}</span>
    </>
  );

  const renderPaginationButtons = () => (
    <div className="Pagination">
      <div onClick={prevPage} className={currentPage <= 0 ? 'disabled' : ''}>
        <FaFastBackward size="1em" />
      </div>

      <span>{currentPage+1}</span>

      <div onClick={nextPage} className={!isNextPageAvailable ? 'disabled' : ''}>
        <FaFastForward size="1em" />
      </div>
    </div>
  );

  return (
    <PaginationArea>
      <RowsDropdown>{renderRowsPerPageDropdown()}</RowsDropdown>
      <PaginationButtons>{renderPaginationButtons()}</PaginationButtons>
    </PaginationArea>
  );
};
